import { gql } from '@apollo/client'

export const GENERATE_TERRA_SDK_TOKEN = gql`
  query generateTerraSdkToken {
    generateTerraSdkToken {
      token
    }
  }
`
